'use client';

import { useState, useEffect } from 'react';

let bigDay: { [key: string]: string } = {
  day: '19',
  month: '02',
  year: '26',
};

const Countdown = () => {
  const calculateTimeLeft = () => {
    const difference = +new Date('2026-02-19T00:00:00') - +new Date();
    let timeLeft: { [key: string]: number } = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
      };
    }

    return timeLeft;
  };
  const isDatePassed = () => {
    const difference = +new Date('2026-02-20T00:00:00') - +new Date();
    return difference < 0;
  };

  const [timeLeft, setTimeLeft] = useState<{ [key: string]: number }>({});
  const [mounted, setMounted] = useState(false);
  const [datePassed, setDatePassed] = useState(false);

  useEffect(() => {
    setMounted(true);
    setTimeLeft(calculateTimeLeft());
    setDatePassed(isDatePassed());
  }, []);

  useEffect(() => {
    if (!mounted) return;

    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
      setDatePassed(isDatePassed());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const timerComponents: JSX.Element[] = [];

  Object.keys(timeLeft).forEach((interval) => {
    const value = timeLeft[interval];
    // A check to see if the value is a number and not undefined.
    if (typeof value !== 'number') {
      return;
    }

    const formattedValue = String(value).padStart(2, '0');
    const [firstDigit, secondDigit] = formattedValue;

    timerComponents.push(
      <div key={interval} className="flex flex-col items-center mx-1 md:mx-2">
        <div className="flex gap-1">
          <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center text-3xl md:text-5xl font-bold bg-gray-800 text-white rounded-lg">{firstDigit}</div>
          <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center text-3xl md:text-5xl font-bold bg-gray-800 text-white rounded-lg">{secondDigit}</div>
        </div>
        <div className="text-xs md:text-sm uppercase font-semibold mt-2">{interval}</div>
      </div>
    );
  });

  let timerText = (<span>Countdown To The Big Day</span>);
  if (!timerComponents.length) {
    timerText = (<span>The Big Day Is Here!</span>);
    if (datePassed) {
      timerText = (<span>It was an amazing day!</span>);
    }
  }

  if (!mounted) {
    return (
      <div className="flex flex-col items-center my-8">
        <div className="flex justify-center">
          {['days', 'hours', 'minutes'].map((interval) => (
            <div key={interval} className="flex flex-col items-center mx-1 md:mx-2">
              <div className="flex gap-1">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-gray-800 rounded-lg" />
                <div className="w-12 h-12 md:w-16 md:h-16 bg-gray-800 rounded-lg" />
              </div>
              <div className="text-xs md:text-sm uppercase font-semibold mt-2">
                <span className="invisible">{interval}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 text-lg invisible">Countdown To The Big Day</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center my-8">
      <div className="flex justify-center">
        {timerComponents.length ? (
          timerComponents
        ) : (
          <>
            {['day', 'month', 'year'].map((interval) => (
              <div key={interval} className="flex flex-col items-center mx-1 md:mx-2">
                <div className="flex gap-1">
                  <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center text-3xl md:text-5xl font-bold bg-gray-800 text-white rounded-lg">{bigDay[interval][0]}</div>
                  <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center text-3xl md:text-5xl font-bold bg-gray-800 text-white rounded-lg">{bigDay[interval][1]}</div>
                </div>
                <div className="text-xs md:text-sm uppercase font-semibold mt-2">{interval}</div>
              </div>
            ))}
          </>
        )}
      </div>
      <div className="mt-4 text-lg">
        {timerText}
      </div>
    </div>
  );
};

export default Countdown;